export default __webpack_public_path__ + "static/media/logo.b1f686e6.png";